var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginRightPolygonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 72.615,
    height: 71.631,
    viewBox: "0 0 72.615 71.631",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:rgba(175,57,254,0.98);}.b{fill:#fff;}.c{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#f3eee2",
    floodOpacity: 0.492,
    result: "c"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "c"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M27,0,54,49H0Z",
    transform: "matrix(0.799, -0.602, 0.602, 0.799, 0, 32.498)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M27,0,54,49H0Z",
    transform: "matrix(0.8, -0.6, 0.6, 0.8, 0, 32.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginRightPolygonIcon);
export default __webpack_public_path__ + "static/media/login-right-polygon-icon.2fead07189cfc9b8e4d1f7e3021f290a.svg";
export { ForwardRef as ReactComponent };